/**
 * ADR-012 — MS-COM-046 auth wrapper only; canonical tree is `/:tenantCode/donate/*`.
 * Previously redirected authenticated users to `/account/donate` (duplicate tree).
 */
import { Outlet } from 'react-router-dom';

export function DonateAuthenticatedRedirect(): JSX.Element {
  return <Outlet />;
}
